// extracted by css-extract-rspack-plugin
export default {"pagination":"N8qI9l1p18QMKCeo","hud":"ExlYdB0ynYsD2A8n"};